module.exports = __webpack_public_path__ + "img/congrats.11d7d5a5.gif";